import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Navigation from './header-navigation';

const NavigationSet = (props) => {
  const {
    navigation = [],
    navigationRight = [],
    navigationPosition = 'bot',
    currentHref
  } = props;
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // The useEffect Hook runs after the component output has been rendered to the DOM.
    // This is a good place to set the isClient state to true.
    setIsClient(true);
  }, []);


  const emptyNav = useMemo(() => navigation.every(navItem => !navItem.caption), [navigation]);
  const emptyNavRight = useMemo(() => navigationRight.every(navItem => !navItem.caption), [navigationRight]);

  return (
    <>
      {!isClient || (emptyNav && emptyNavRight) ? null :
        (<div className={ `${navigationPosition}-nav-set` }>
          <Navigation
            items={ navigation }
            currentHref={ currentHref }
          />
          <Navigation
            items={ navigationRight }
            currentHref={ currentHref }
            side='right'
          />
        </div>)
      }
    </>
  );
};

NavigationSet.propTypes = {
  currentHref: PropTypes.string,
  navigation: PropTypes.array.isRequired,
  navigationRight: PropTypes.array,
  navigationPosition: PropTypes.oneOf(['bot', 'top', 'right'])
};

export default NavigationSet;
